<template>
    <div class="content-wrapper">
        <section class="content-header">
            <h1>{{ $t('addNew') }} {{ $t('offer.tag.tag') }}</h1>
        </section>

        <section class="content">
            <Alerts />

            <div class="row">
                <div class="col-xs-12">
                    <div class="box box-primary">
                        <div
                            v-if="!isLoaded"
                            class="box-body"
                        >
                            <img
                                class="table-row-preloader"
                                rel="preload"
                                src="/img/table-row-preloader.gif"
                            />
                        </div>

                        <OffersTagsForm
                            v-show="isLoaded"
                            @loaded="isLoaded = true"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import OffersTagsForm from '@/components/offers/tags/OffersTagsForm';

export default {
    components: {
        OffersTagsForm,
    },
    data() {
        return {
            isLoaded: false,
        };
    },
    computed: {
        headTitle() {
            return `${this.$t('addNew')} ${this.$t('offer.tag.tag')}`;
        },
    },
};
</script>
